import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.74 8.182c-.134.108-2.482 1.492-2.482 4.572 0 3.561 2.988 4.821 3.078 4.852-.014.077-.475 1.726-1.576 3.406-.981 1.478-2.006 2.954-3.566 2.954s-1.96-.948-3.76-.948c-1.755 0-2.379.98-3.805.98-1.426 0-2.422-1.368-3.566-3.048C1.738 18.977.667 15.912.667 13.003c0-4.665 2.898-7.14 5.751-7.14 1.516 0 2.78 1.042 3.731 1.042.906 0 2.318-1.104 4.043-1.104.653 0 3.002.062 4.547 2.38Zm-5.367-4.356c.713-.886 1.218-2.115 1.218-3.344 0-.17-.014-.343-.044-.482-1.16.046-2.54.809-3.373 1.82-.653.777-1.263 2.006-1.263 3.251 0 .187.03.375.043.435.073.014.193.03.312.03 1.041 0 2.35-.729 3.107-1.71Z",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgApple as default };
//# sourceMappingURL=apple.svg.js.map
